import type { Message, MessageKeysetListMeta } from '@/types/chat.type'

function toBase64Url(value: string): string {
  if (typeof globalThis.btoa === 'function' && typeof TextEncoder !== 'undefined') {
    const bytes = new TextEncoder().encode(value)
    let binary = ''
    for (let i = 0; i < bytes.length; i += 1) {
      binary += String.fromCharCode(bytes[i])
    }

    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
  }

  return Buffer.from(value, 'utf8').toString('base64url')
}

export function encodeMessageKeysetCursor(
  message: Pick<Message, 'id' | 'createdAt'>
): string {
  const payload = JSON.stringify({
    createdAt: new Date(message.createdAt).toISOString(),
    id: message.id,
  })

  return toBase64Url(payload)
}

export function resolveKeysetHasPrevious(
  meta: MessageKeysetListMeta | undefined,
  loadedCount: number,
  pageSize: number
): boolean {
  if (typeof meta?.hasPrevious === 'boolean') {
    return meta.hasPrevious
  }

  return loadedCount >= pageSize
}

export function resolveKeysetHasMore(
  meta: MessageKeysetListMeta | undefined,
  loadedCount: number,
  pageSize: number
): boolean {
  if (typeof meta?.hasMore === 'boolean') {
    return meta.hasMore
  }

  return loadedCount >= pageSize
}
